export const RESET_LICENSE = "RESET_LICENSE";
export const LOAD_LICENSE = "LOAD_LICENSE";
export const SET_PROCESSING = "SET_PROCESSING";
export const GET_LICENSE = "GET_BANK_LICENSE";
export const UPDATE_BANK_LICENSE = "UPDATE_BANK_LICENSE";
export const CHANGE_BANK_LICENSE = "CHANGE_BANK_LICENSE";
export const CUSTOMIZE_MODULES = "CUSTOMIZE_MODULES";
export const LOAD_LICENSE_HISTORY = "LOAD_LICENSE_HISTORY";
export const GET_LICENSE_HISTORY = "GET_LICENSE_HISTORY";
export const GET_MODULES = "GET_MODULES";
